/* lib/PostcodeLookup/Input.svelte generated by Svelte v3.24.0 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	destroy_each,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	listen_dev,
	noop,
	prevent_default,
	prop_dev,
	run_all,
	safe_not_equal,
	set_data_dev,
	set_input_value,
	space,
	stop_propagation,
	text,
	validate_each_argument,
	validate_slots
} from "svelte/internal";

import { getContext } from "svelte";
const file = "lib/PostcodeLookup/Input.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

// (45:2) {#if completions && completions.length > 0}
function create_if_block(ctx) {
	let datalist;
	let each_value = /*completions*/ ctx[2];
	validate_each_argument(each_value);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const block = {
		c: function create() {
			datalist = element("datalist");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr_dev(datalist, "id", "autocomplete");
			add_location(datalist, file, 45, 2, 1032);
		},
		m: function mount(target, anchor) {
			insert_dev(target, datalist, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(datalist, null);
			}
		},
		p: function update(ctx, dirty) {
			if (dirty & /*completions*/ 4) {
				each_value = /*completions*/ ctx[2];
				validate_each_argument(each_value);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(datalist, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(datalist);
			destroy_each(each_blocks, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(45:2) {#if completions && completions.length > 0}",
		ctx
	});

	return block;
}

// (47:4) {#each completions as completion}
function create_each_block(ctx) {
	let option;
	let t_value = /*completion*/ ctx[9] + "";
	let t;
	let option_value_value;

	const block = {
		c: function create() {
			option = element("option");
			t = text(t_value);
			option.__value = option_value_value = /*completion*/ ctx[9];
			option.value = option.__value;
			add_location(option, file, 47, 6, 1105);
		},
		m: function mount(target, anchor) {
			insert_dev(target, option, anchor);
			append_dev(option, t);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*completions*/ 4 && t_value !== (t_value = /*completion*/ ctx[9] + "")) set_data_dev(t, t_value);

			if (dirty & /*completions*/ 4 && option_value_value !== (option_value_value = /*completion*/ ctx[9])) {
				prop_dev(option, "__value", option_value_value);
				option.value = option.__value;
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(option);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_each_block.name,
		type: "each",
		source: "(47:4) {#each completions as completion}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let div;
	let label;
	let t0;
	let label_class_value;
	let t1;
	let input;
	let input_class_value;
	let t2;
	let t3;
	let button;
	let t4;
	let button_class_value;
	let div_class_value;
	let mounted;
	let dispose;
	let if_block = /*completions*/ ctx[2] && /*completions*/ ctx[2].length > 0 && create_if_block(ctx);

	const block = {
		c: function create() {
			div = element("div");
			label = element("label");
			t0 = text("Postcode Lookup");
			t1 = space();
			input = element("input");
			t2 = space();
			if (if_block) if_block.c();
			t3 = space();
			button = element("button");
			t4 = text("Lookup");
			attr_dev(label, "class", label_class_value = /*classNames*/ ctx[1].label);
			attr_dev(label, "for", "postcode-lookup-input");
			add_location(label, file, 40, 2, 743);
			attr_dev(input, "id", "postcode-lookup-input");
			attr_dev(input, "list", "autocomplete");
			attr_dev(input, "class", input_class_value = /*classNames*/ ctx[1].input);
			attr_dev(input, "placeholder", "Enter your postcode");
			attr_dev(input, "type", "text");
			add_location(input, file, 43, 2, 837);
			attr_dev(button, "class", button_class_value = /*classNames*/ ctx[1].button);
			attr_dev(button, "type", "submit");
			add_location(button, file, 51, 2, 1171);
			attr_dev(div, "data-testid", "container");
			attr_dev(div, "class", div_class_value = /*classNames*/ ctx[1].container);
			add_location(div, file, 39, 0, 682);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			append_dev(div, label);
			append_dev(label, t0);
			append_dev(div, t1);
			append_dev(div, input);
			set_input_value(input, /*value*/ ctx[0]);
			append_dev(div, t2);
			if (if_block) if_block.m(div, null);
			append_dev(div, t3);
			append_dev(div, button);
			append_dev(button, t4);

			if (!mounted) {
				dispose = [
					listen_dev(input, "input", /*input_input_handler*/ ctx[6]),
					listen_dev(button, "click", stop_propagation(prevent_default(/*handleClick*/ ctx[3])), false, true, true)
				];

				mounted = true;
			}
		},
		p: function update(ctx, [dirty]) {
			if (dirty & /*classNames*/ 2 && label_class_value !== (label_class_value = /*classNames*/ ctx[1].label)) {
				attr_dev(label, "class", label_class_value);
			}

			if (dirty & /*classNames*/ 2 && input_class_value !== (input_class_value = /*classNames*/ ctx[1].input)) {
				attr_dev(input, "class", input_class_value);
			}

			if (dirty & /*value*/ 1 && input.value !== /*value*/ ctx[0]) {
				set_input_value(input, /*value*/ ctx[0]);
			}

			if (/*completions*/ ctx[2] && /*completions*/ ctx[2].length > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div, t3);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*classNames*/ 2 && button_class_value !== (button_class_value = /*classNames*/ ctx[1].button)) {
				attr_dev(button, "class", button_class_value);
			}

			if (dirty & /*classNames*/ 2 && div_class_value !== (div_class_value = /*classNames*/ ctx[1].container)) {
				attr_dev(div, "class", div_class_value);
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
			if (if_block) if_block.d();
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { value = "" } = $$props;
	let { classNames = {} } = $$props;
	let { onLookup = () => null } = $$props;
	let { getClient = getContext("client") } = $$props;
	let response;
	let completions;

	const getAutocompletions = async () => {
		$$invalidate(2, completions = null);

		if (!value || value.length < 2) {
			return false;
		}

		response = await getClient().getAutocomplete(value);

		if (!response.isCompleted) {
			$$invalidate(2, completions = response.listCompletions());
			return;
		}

		const [[postcode]] = response;
		onLookup(postcode);
	};

	const handleClick = () => onLookup(value);
	const writable_props = ["value", "classNames", "onLookup", "getClient"];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== "$$") console.warn(`<Input> was created with unknown prop '${key}'`);
	});

	let { $$slots = {}, $$scope } = $$props;
	validate_slots("Input", $$slots, []);

	function input_input_handler() {
		value = this.value;
		$$invalidate(0, value);
	}

	$$self.$set = $$props => {
		if ("value" in $$props) $$invalidate(0, value = $$props.value);
		if ("classNames" in $$props) $$invalidate(1, classNames = $$props.classNames);
		if ("onLookup" in $$props) $$invalidate(4, onLookup = $$props.onLookup);
		if ("getClient" in $$props) $$invalidate(5, getClient = $$props.getClient);
	};

	$$self.$capture_state = () => ({
		getContext,
		value,
		classNames,
		onLookup,
		getClient,
		response,
		completions,
		getAutocompletions,
		handleClick
	});

	$$self.$inject_state = $$props => {
		if ("value" in $$props) $$invalidate(0, value = $$props.value);
		if ("classNames" in $$props) $$invalidate(1, classNames = $$props.classNames);
		if ("onLookup" in $$props) $$invalidate(4, onLookup = $$props.onLookup);
		if ("getClient" in $$props) $$invalidate(5, getClient = $$props.getClient);
		if ("response" in $$props) response = $$props.response;
		if ("completions" in $$props) $$invalidate(2, completions = $$props.completions);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*value*/ 1) {
			$: (value, getAutocompletions());
		}
	};

	return [
		value,
		classNames,
		completions,
		handleClick,
		onLookup,
		getClient,
		input_input_handler
	];
}

class Input extends SvelteComponentDev {
	constructor(options) {
		super(options);

		init(this, options, instance, create_fragment, safe_not_equal, {
			value: 0,
			classNames: 1,
			onLookup: 4,
			getClient: 5
		});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Input",
			options,
			id: create_fragment.name
		});
	}

	get value() {
		throw new Error("<Input>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set value(value) {
		throw new Error("<Input>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get classNames() {
		throw new Error("<Input>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set classNames(value) {
		throw new Error("<Input>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get onLookup() {
		throw new Error("<Input>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set onLookup(value) {
		throw new Error("<Input>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get getClient() {
		throw new Error("<Input>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set getClient(value) {
		throw new Error("<Input>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default Input;